var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title-attraction"},[_vm._v("\n  More about fondi\n  "),_c('div',{staticClass:"title-text-sm"},[_vm._v(_vm._s(_vm.$t('lp.app-more')))])])}
var staticRenderFns = []

export { render, staticRenderFns }